import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { useTranslate } from "react-admin";
import reportTranslator from "../../../../../../utils/reportTranslator";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "10px",
    height: "78px",
    minWidth: "120px",
    borderRadius: 10,
    border: "3px solid #EBEBEB",
    color: "#828282",
    display: "grid",
    placeItems: "center",
  },

  ColorsTextBox: {
    color: "#FA9917",
    fontSize: "24px",
    margin: "10px",
    minHeight: "100px",
    borderRadius: 10,
    border: "4px solid #EBEBEB",
    textAlign: "left",
  },
  ColorTextBoxSecond: {
    color: "#828282",
    fontSize: "24px",
    margin: "10px",
    minHeight: "100px",
    borderRadius: 10,
    border: "4px solid #EBEBEB",
  },
  CardContentMixed: {
    display: "flex",
    flexDirection: "column",
    minHeight: "99px",
    justifyContent: "center",
    padding: 6,
  },
  ColorsTextBoxSingle: {
    color: "#FA9917",
    fontSize: "24px",
    margin: "10px",
    minWidth: "120px",
    minHeight: "78px",
    borderRadius: 10,
    border: "4px solid #EBEBEB",
    textAlign: "center",
    display: "grid",
    placeItems: "center",
  },
  // typography: {
  //   fontFamily: ["Myriad Pro", "sans-serif"].join(","),
  // },
  topicOrange: {
    color: theme.orange,
    fontSize: 16,
  },
  topicNormal: {
    color: theme.darkGray,
    fontSize: 16,
  },
  valueOrange: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bolder",
  },
  GridMultiple: { textAlign: "left" },
  TypographyKey: {
    fontSize: "14px",
  },
  TypographyVal: {
    fontWeight: 800,
    fontSize: "14px",
  },
  TypographyMultiple: { fontWeight: 600, fontSize: 16 },
  TypographySingle: {
    fontSize: 30,
    fontWeight: "bolder",
  },
  CardContentSingle: {
    textAlign: "center",
    padding: "0 !important",
    display: "grid",
    placeItems: "center",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,  minmax(100px , 1fr))",
  },
  tierParentContainer: {
    display: "grid",
    gridTemplateColumns: "200px auto",
  },
  twoValuesContent: {
    fontSize: "1rem",
    fontWeight: "bolder",
  },
  summaryBoxGrid: {
    display: "grid",
    gridTemplateColumns: "70% 30%",
    gridTemplateRows: "20px 20px 20px",
    padding: 0,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: "0 !important",
    width: "100%",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  tierContainer: {
    margin: "10px",
    height: "78px",
    minWidth: "690px",
    borderRadius: 10,
    border: "4px solid #EBEBEB",
    color: "#828282",
    display: "grid",
    placeItems: "center",
  },
  tierCardContent: {
    padding: "0 !important",
    paddingLeft: "15px !important",
    paddingRight: "15px !important",
    width: "100%",
    boxSizing: "border-box",
  },
  threeContainer: {
    margin: "10px",
    height: "78px",
    minWidth: "80px",
    paddingLeft: 10,
    borderRadius: 10,
    border: "4px solid #EBEBEB",
    color: "#828282",
    display: "grid",
  },
}));

export default function CardTotal(props) {
  const classes = useStyles();
  const translate = useTranslate();
  const formatNumber = (val) => {
    if (!val) return "-";
    if (typeof val == "string") return val;
    else return val.toLocaleString();
  };

  // (+val)
  //   .toFixed(2)
  //   .replace(/\d(?=(\d{3})+\.)/g, "$&,")
  //   .split(".")[0];

  if (!props.value) {
    return <Typography variant="h4">NO DATA</Typography>;
  }

  return (
    <Box
      className={
        props.tierBox ? classes.tierParentContainer : classes.container
      }
    >
      {Object.entries(props.value).map(([key, val], index) => {
        return (
          <Box key={index}>
            <Card
              className={
                index === 0 ? classes.ColorsTextBoxSingle : classes.root
              }
              variant="outlined"
            >
              <CardContent className={classes.CardContentSingle}>
                <Typography
                  className={
                    index === 0 ? classes.topicOrange : classes.normalTopic
                  }
                >
                  {translate(reportTranslator(key))}
                </Typography>
                <Typography
                  className={
                    index === 0 ? classes.valueOrange : classes.TypographySingle
                  }
                >
                  {formatNumber(val)}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        );
      })}
      {props.threeValues?.map((boxes, boxIndex) => {
        return (
          <Box key={boxIndex}>
            <Card variant="outlined" className={classes.threeContainer}>
              <Box style={{ padding: "5px" }}>
                {boxes.map((b, index) => {
                  return (
                    <>
                      <Typography
                        style={{
                          fontSize: "0.75rem",
                          fontWeight: index === 0 ? "bolder" : "standard",
                          color: boxIndex === 0 ? "orange" : "gray",
                        }}
                      >
                        {b}
                      </Typography>
                    </>
                  );
                })}
              </Box>
            </Card>
          </Box>
        );
      })}
      {props.summaryBoxes?.map((box, index) => {
        return (
          <Box key={index}>
            <Card variant="outlined" className={classes.root}>
              <CardContent className={classes.summaryBoxGrid}>
                <Typography
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "bolder",
                    color: "orange",
                  }}
                >
                  {translate(reportTranslator(box.title))}
                </Typography>
                <Typography
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "bolder",
                    color: "orange",
                  }}
                >
                  {box.titleValue}
                </Typography>
                {box.list.map((item) => {
                  return (
                    <>
                      <Typography
                        style={{ fontSize: "0.7rem", color: "orange" }}
                      >
                        {translate(reportTranslator(item.label))}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "0.7rem",
                          fontWeight: "bolder",
                          color: "orange",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </>
                  );
                })}
              </CardContent>
            </Card>
          </Box>
        );
      })}
      {props.tierBox && (
        <Box>
          <Card variant="outlined" className={classes.tierContainer}>
            <CardContent className={classes.tierCardContent}>
              <Box
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
                  justifyContent: "stretch",
                }}
              >
                {props.tierBox.headers.map((header) => {
                  return (
                    <Typography
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "bolder",
                        width: "100%",
                      }}
                    >
                      {header}
                    </Typography>
                  );
                })}
              </Box>
              {props.tierBox.list.map((datas) => {
                return (
                  <Box
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(80px, 1fr))",
                      justifyContent: "stretch",
                    }}
                  >
                    {datas.map((data) => {
                      return (
                        <Typography
                          style={{ fontSize: "0.8rem", width: "100%" }}
                        >
                          {data}
                        </Typography>
                      );
                    })}
                  </Box>
                );
              })}
            </CardContent>
          </Card>
        </Box>
      )}
      {props.twoValues?.map((item, index) => {
        return (
          <Box key={index}>
            <Card variant="outlined" className={classes.root}>
              <CardContent className={classes.CardContentSingle}>
                <Typography noWrap style={{ width: "100%" }}>
                  {item[0] ?? ""}
                </Typography>
                <Typography
                  noWrap
                  style={{ width: "100%" }}
                  className={classes.twoValuesContent}
                >
                  {item[1] ?? ""}
                </Typography>
                <Typography
                  noWrap
                  style={{ width: "100%" }}
                  className={classes.twoValuesContent}
                >
                  {item[2] ?? ""}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        );
      })}
    </Box>
  );
}
